export default "__VITE_ASSET__57570bbd__"